document.addEventListener('DOMContentLoaded', function() {
  if (!('IntersectionObserver' in window)) return;
  var fadeTargets = document.querySelectorAll(
    '[data-section-id="178101850331962535"] h2, [data-section-id="178101850331962535"] p, [data-section-id="section_yKFyc4"] h2, [data-section-id="section_yKFyc4"] p'
  );
  var fadeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry, i) {
      if (entry.isIntersecting) {
        entry.target.style.animationDelay = (i * 0.12) + 's';
        entry.target.classList.add('deservia-animate-fadeup');
        entry.target.style.opacity = '';
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  fadeTargets.forEach(function(el) { el.style.opacity = '0'; fadeObserver.observe(el); });

  // Count-up 12.000+
  var statEls = document.querySelectorAll('[data-section-id="178101850331962535"] [class*="stat"], [data-section-id="178101850331962535"] [class*="number"], [data-section-id="178101850331962535"] [class*="count"]');
  var countObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var t = 12000, d = 2200, s = Date.now();
      function tick() {
        var p = Math.min((Date.now()-s)/d, 1), e = 1-Math.pow(1-p,3);
        el.textContent = Math.floor(e*t) >= t ? '12.000+' : Math.floor(e*t).toLocaleString('it-IT')+'+';
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      countObserver.unobserve(el);
    });
  }, { threshold: 0.5 });
  statEls.forEach(function(el) { countObserver.observe(el); });
});
